//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
export default {
  name: 'MemberBenefitsBox',
  components: {
    SfButton
  },
  props: {
    benefitsTitle: {
      type: String,
    },
    backgroundColor: {
      type: String,
    },
    registerLabel: {
      type: String,
    },
    registerButtonText: {
      type: String,
    },
    link: {
      type: [Object, String],
    },
    benefits: {
      type: String,
    },
    benefitsImage: {
      type: Object,
      default: () => ({
        desktop: '',
        mobile: '',
      }),
    }
  },
};
